import {
    server_config,
    server_result,
    behavior_config,
    states,
    rotated,
    ico_he,
    reels_pos,
    round_running,
    set_rotated,
    reels_lenghts,
    forcestopnow,
    set_inanim,
    set_inwincount,
    wi,
    picture_convert,
    big_win,
    set_forcestopnow,
    set_inmoneyadd, set_inbigwin, set_in_free_spins, in_free_spins, set_server_result
} from "../framework/src/engine/madnes/madnes_variables";
import * as MV from "../framework/src/engine/madnes/madnes_variables";
import {
    lines_count,
    madnes_add_win,
    madnes_end_round,
    madnes_get_atomic_bet,
    madnes_get_currtime,
    madnes_is_in_autostart,
    madnes_money_to_coin,
    madnes_reels_start,
    madnes_reels_stop,
    madnes_set_win,
    madnes_win_anim_reset,
    madnes_win_anim_skip,
    win
} from "../framework/src/engine/madnes/madnes";
import {set_blink_state} from "./joker27plus_reels";
import {cylinder_pos, icons, last_symbol, symbols} from "./joker27plus_config";
import {
    madnes_audio_continue,
    madnes_audio_fade_out, madnes_audio_fade_to, madnes_audio_get_volume, madnes_audio_is_playing,
    madnes_audio_loop,
    madnes_audio_pause,
    madnes_audio_play, madnes_audio_set_volume,
    madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";
import {
    madnes_scale_to,
    madnes_add_to_render,
    madnes_alpha_to,
    madnes_move_to,
    madnes_rem_from_render
} from "../framework/src/engine/madnes/madnes_render";
import {
    madnes_anim_add,
    madnes_anim_is_playing,
    madnes_anim_play,
    madnes_show_money
} from "../framework/src/engine/madnes/madnes_anims";
import {joker27plus_print_reels, result_lock, set_result_lock} from "./joker27plus_core_printer";
import {
    madnes_get_alpha, madnes_get_pos_y, madnes_get_scale_y, madnes_get_texture, madnes_set_alpha, madnes_set_pos,
    madnes_set_pos_y,
    madnes_set_scale,
    madnes_set_texture
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {
    joker27plus_fs_start_anim,
    joker27plus_fs_vibrate_end,
    joker27plus_fullplate_start,
    joker27plus_windesk_show
} from "./joker27plus_anims";
import {STATES} from "../framework/src/states/states";
import AddResult from "../framework/src/connect/result/AddResult";
import events from "../framework/src/events/EventsObservable";
import {REELS_EVENTS} from "../framework/src/game/slot/reelsEvents";
import {GAME_EVENTS} from "../framework/src/game/gameEvents";

var rotate_start_time = 0;
var rotate_start_pos = [];
var rotate_start_in_accel = 0;
var rotate_start_swing = 0;
var can_stop = 0;
var rotate_control_start_time = 0;
var rotate_control_swing_end = 0;

export function joker27plus_rotate_run()
{
    if(round_running) //waiting for end round
    {
        return;
    }

    madnes_reels_start();
    joker27plus_rotate_start();
}

function joker27plus_rotate_start()
{
    if(rotated == 0)
    {
        // madnes_on_round_start();

        // madnes_audio_play("button_click");

        joker27plus_fs_vibrate_end();

        // madnes_show_stop();

        madnes_win_anim_reset();

        for(var i in server_config.logic.reels)
        {
            while(stopposin[i] > server_config.logic.reels[i].length)
            {
                stopposin[i] = stopposin[i] * 1 - server_config.logic.reels[i].length;
                stopposin_old[i] = stopposin[i];
                reels_pos[i] = stopposin[i] * ico_he;
            }
        }

        // if(autostart != "∞" && autostart*1 > 0 && !in_free_spins)
        // {
        // 	autostart = autostart*1-1;
        // }
        set_rotated(1); //rotated = 1;
        set_blink_state("rotate"); //blink_state = "rotate";

        startposin = JSON.parse(JSON.stringify(stopposin));

        // if(!in_free_spins)
        // {
        // 	madnes_new_round();
        // 	force_res = "";
        // }

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            symbols[i] = 0;
            last_symbol[i] = -1;
            rotate_start_pos[i] = reels_pos[i];
        }

        can_stop = 0;

        rotate_start_time = madnes_get_currtime();

        rotate_control_start_time = 0;
        rotate_start_in_accel = 0;
        rotate_start_swing = 0;
        set_forcestopnow(0); //forcestopnow = 0;
        scatters_runned = false;

        madnes_audio_play("REEL_START");

        madnes_add_to_render(joker27plus_rotate_start);
        // madnes_reels_start()
    }
    else
    {
        var time = madnes_get_currtime() - rotate_start_time;

        if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            time < behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // back
            var time_perc = ( ( 100 / ( behavior_config.reel.acceleration.moveBackTime * 1000 ) ) * time ) / 100;
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // keep
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * 1 );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            //time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveTime * 1000 &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // acc

            var time_perc =
                1 - (
                    (
                        (
                            100 / (
                                //behavior_config.reel.acceleration.moveTime * 1000
                                behavior_config.reel.acceleration.moveBackTime * 1000
                            )
                        ) * (
                            time - (
                                behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000
                            )
                        )
                    ) / 100
                );

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }

        }
        else if(
            rotate_start_in_accel == 0
        )
        {
            // rotate accel start or repeat

            madnes_audio_play("reel_Start");
            madnes_audio_loop("reel_Spin");

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i];
            }

            rotate_start_time = madnes_get_currtime();

            if(++rotate_start_swing >= behavior_config.reel.acceleration.swingCount)
            {

                for(var i = 0; i < cylinder_pos.length; i++)
                {
                    if(behavior_config.reel.spin.motionBlur == 1)
                    {
                        madnes_anim_play("reels_bufer_" + i + "_S0", "blur");
                        madnes_anim_play("reels_bufer_" + i + "_S1", "blur");
                        madnes_anim_play("reels_bufer_" + i + "_S2", "blur");

                        for(var j = 0; j < reels_lenghts[i]; j++)
                        {
                            madnes_anim_play("reels_bufer_" + i + "_" + j, "blur");
                        }

                    }
                }

                rotate_start_in_accel = 1;

                // joker27plus_rotate_control_start_sym = Math.round(rotate_start_pos[0] / ico_he);
                rotate_control_start_time = madnes_get_currtime();
            }
        }
        else if(
            rotate_start_in_accel == 1
        )
        {
            // accel start
            var start_speed = behavior_config.reel.acceleration.accelerationHeight / behavior_config.reel.acceleration.moveBackTime;

            if(!isFinite(start_speed) || isNaN(start_speed))
            {
                start_speed = 0;
            }

            var end_speed = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                end_speed = behavior_config.reel.spin.freeSpinSpeed;
            }

            var end_time = behavior_config.reel.spin.timeToReachFullSpeed * 1000;

            var perc = 0;
            var speed = 0;
            var pos = 0;
            var sampling = 10;

            for(var i = 0; i <= time; i = i * 1 + sampling * 1)
            {
                perc = 100 / end_time * i;
                if(!isFinite(perc) || isNaN(perc))
                {
                    perc = 0;
                }
                speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
            }

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] + pos * ico_he;
            }

            if(
                !(
                    time < behavior_config.reel.spin.timeToReachFullSpeed * 1000
                )
            )
            {
                pos = 0;

                for(var i = 0; i <= ( behavior_config.reel.spin.timeToReachFullSpeed * 1000 ); i = i * 1 + sampling * 1)
                {
                    perc = 100 / end_time * i;
                    if(!isFinite(perc) || isNaN(perc))
                    {
                        perc = 0;
                    }
                    speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                    pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
                }

                rotate_control_swing_end = pos;

                madnes_rem_from_render(joker27plus_rotate_start);
                madnes_add_to_render(joker27plus_rotate_control);
            }
        }

        joker27plus_print_reels();
    }
}

// Kontrola probihajici rotace valcu
var alldone = new Array();

export var stopposin = new Array();
export var startposin = new Array();

var stopposin_round = new Array();
var stopping = new Array();

export var stopposin_old = new Array();
var stoppostime_br = new Array();
var stoppostime = new Array();

var stoppos_swing = new Array();

var scatters = 0;
var saloons = 0;
var all_set_for_stop = 0;

var scatters_runned = false;
function joker27plus_rotate_control()
{

    var time = madnes_get_currtime();

    if(rotated == 1 || all_set_for_stop == 0)
    {
        // Toci se a zatim se neceka ukonceni

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(server_result != null && result_lock == 0)
            {
                stopposin[i] = -1;
                stopposin_round[i] = 0;
                stopping[i] = 0;
                stoppostime_br[i] = -1;
                stoppos_swing[i] = 0;
                stoppostime[i] = -1;
                can_stop = 1;
            }

            alldone[i] = 0;

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }

            reels_pos[i] =
                (
                    rotate_start_pos[i] +
                    (
                        (
                            (
                                (
                                    time - rotate_control_start_time - (
                                        behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                    )
                                ) / 1000
                            ) * cs
                        ) + rotate_control_swing_end
                    ) * ico_he
                );
            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );
        }

        scatters = 0;
        saloons = 0;

    }
    else
    {
        // Je na case ukoncit toceni na spravnych pozicich

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(stopposin[i] == -1)
            {
                // Nejsou nastaveny pozice pro ukonceni -> nastavuji
                if(forcestopnow == 1)
                {
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + ( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i];
                    }

                }
                else
                {
                    var del = 1;
                    if(typeof behavior_config.reel.spin.delayBetweenReelStops != "undefined")
                    {
                        del = behavior_config.reel.spin.delayBetweenReelStops;
                    }
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + /*(i * del) + */( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i] + ( i * del );
                    }
                }

                while(stopposin[i] <= 0)
                {
                    stopposin[i] = ( reels_lenghts[i] * 1 ) - stopposin[i];
                }

                stopposin_old[i] = stopposin[i];
            }

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }
            var end_break_reel_dist = madnes_get_end_dist();

            //var ttrfs = behavior_config.reel.spin.timeToReachFullSpeed;
            var ttrns = behavior_config.reel.spin.timeToReachNullSpeed;

            if(forcestopnow == 1)
            {
                end_break_reel_dist = 0;
                ttrns = 0.01;
            }

            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );

            if(
                forcestopnow == 0 &&
                (
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= symbdiff &&
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= 0
                )
            )
            {
                reels_pos[i] =
                    (
                        rotate_start_pos[i] +
                        (
                            (
                                (
                                    (
                                        time - rotate_control_start_time - (
                                            behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                        )
                                    ) / 1000
                                ) * cs
                            ) + rotate_control_swing_end
                        ) * ico_he
                    );

            }
            else if(stoppostime[i] == -1)
            {
                stopping[i] = 1;

                if(stoppostime_br[i] == -1)
                {
                    stoppostime_br[i] = time;
                }

                var dif_time = time - stoppostime_br[i];

                var cur_end = 0;

                if(dif_time <= ttrns * 1000)
                {
                    dif_time = madnes_get_dist_break(dif_time);

                    reels_pos[i] =
                        (
                            ( ( ( stopposin[i] + 0 ) - ( end_break_reel_dist * 1 ) + ( dif_time * 1 ) ) ) * ico_he

                        );
                }
                else
                {
                    cur_end = 1;
                }

                if(cur_end == 1)
                {
                    stoppostime[i] = time;


                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 ) * ico_he
                        );

                    if(alldone[i] == 0)
                    {
                        control_show_spin(i);
                        joker27plus_control_stop_sound(i);

                        for(var spos = 0; spos <= 2; spos++)
                        {
                            madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "stop")
                        }

                        for(var j = 0; j < reels_lenghts[i]; j++)
                        {
                            madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");
                        }
                    }
                }
            }
            else
            {
                var end_time = stoppostime[i];
                var dif_time = time - end_time;

                var bh = behavior_config.reel.brake.brakeHeight;
                var kt = behavior_config.reel.brake.keepTime;
                var mbt = behavior_config.reel.brake.moveBackTime;
                //var mt = behavior_config.reel.brake.moveTime;
                var mt = behavior_config.reel.brake.moveBackTime;


                var cs = behavior_config.reel.spin.commonSpeed;
                if(in_free_spins)
                {
                    cs = behavior_config.reel.spin.freeSpinSpeed;
                }

                //cs - rychlost
                //bh - vyska
                mt = bh / cs;

                var swc = behavior_config.reel.brake.swingCount;

                if(dif_time < mt * 1000)
                {
                    var add_pos = ( ( (100 / ( mt * 1000 ) ) * dif_time ) / 100 ) * bh;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000)
                {
                    if(i == reels_lenghts.length - 1)
                    {
                        //madnes_audio_stop("reel_Start");
                        madnes_audio_stop("reel_Spin");
                        //madnes_audio_stop("REEL_TEAS");
                    }

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + bh ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000 + mbt * 1000)
                {
                    if(i == reels_lenghts.length - 1)
                    {
                        //madnes_audio_stop("reel_Start");
                        madnes_audio_stop("reel_Spin");
                        //madnes_audio_stop("REEL_TEAS");
                    }

                    var time2 = dif_time - ( mt * 1000 + kt * 1000 );

                    var add_pos = bh - ( ( ( (100 / ( mbt * 1000 ) ) * time2 ) / 100 ) * bh );

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );

                }
                else
                {
                    if(i == reels_lenghts.length - 1)
                    {
                        //madnes_audio_stop("reel_Start");
                        madnes_audio_stop("reel_Spin");
                        //madnes_audio_stop("REEL_TEAS");
                    }

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0  ) * ico_he
                        );

                    if(++stoppos_swing[i] < swc)
                    {
                        stoppostime[i] = time;
                    }
                    else
                    {
                        alldone[i] = 1;
                    }
                }

            }
        }

        if(alldone.indexOf(0) == -1)
        {
            //madnes_audio_stop("reel_Start");
            madnes_audio_stop("reel_Spin");

            //madnes_audio_stop("REEL_TEAS");

            //madnes_hide_stop();

            setTimeout(joker27plus_result_control, 100);
            madnes_rem_from_render(joker27plus_rotate_control);
            // madnes_reels_end();
        }

    }

    joker27plus_print_reels();
}

function control_show_spin(reel) {
    if(reel == 1 && !in_free_spins && !madnes_is_in_autostart())
    {
        states.setState(STATES.FORCESPIN);
        // autospin_force_enabled = true;
        // madnes_show_spin();
    }

}

var madnes_get_end_dist_tmp = -1;
var madnes_get_end_dist_tmp_free = -1;
function madnes_get_end_dist()
{
    if(in_free_spins)
    {
        if(madnes_get_end_dist_tmp_free != -1)
        {
            return madnes_get_end_dist_tmp_free;
        }
    }
    else
    {
        if(madnes_get_end_dist_tmp != -1)
        {
            return madnes_get_end_dist_tmp;
        }
    }

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;
    var distance = madnes_get_dist_break(total_time);

    if(in_free_spins)
    {
        madnes_get_end_dist_tmp_free = distance;
    }
    else
    {
        madnes_get_end_dist_tmp = distance;
    }

    return distance;
}

function madnes_get_dist_break(time)
{
    var sampling = 10;

    var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveBackTime;

    if(!isFinite(end_speed) || isNaN(end_speed))
    {
        end_speed = 0;
    }

    var start_speed = behavior_config.reel.spin.commonSpeed;
    if(in_free_spins)
    {
        start_speed = behavior_config.reel.spin.freeSpinSpeed;
    }

    end_speed = start_speed;

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;

    var distance = 0;

    for(var i = 0; i <= time; i += sampling)
    {
        var proc = 100 - ( ( 100 / total_time ) * i );
        var speed = ( ( start_speed - end_speed ) * ( proc / 100 ) ) + end_speed;
        distance = ( distance * 1 ) + ( speed * sampling ) ;
    }
    distance = distance / 1000;
    return distance;
}

// Pozadavek na dotoceni valce
var joker27plus_rotate_stop_loading = 0;
export function joker27plus_rotate_stop()
{
    if (!(rotated != 0 && joker27plus_rotate_stop_loading == 0)) {
        return;
    }
    for (var i = 0; i < cylinder_pos.length; i++) {
        stopposin_old[i] = -1;
    }
    all_set_for_stop = 0;
    joker27plus_rotate_stop_loading = 1;
    var poss = 0;
    for (var i in server_result.result.reelMatrix[0]) {
        for (var j in server_result.result.reelMatrix[0][i]) {
            madnes_set_texture("reels_bufer_" + i + "_S" + (2 - j), picture_convert[server_result.result.reelMatrix[0][i][j]] + "_blur");

            madnes_anim_add("reels_bufer_" + i + "_S" + (2 - j), "stop", [1]);
            madnes_anim_add("reels_bufer_" + i + "_S" + (2 - j), "blur", [0]);

            if (behavior_config.reel.spin.motionBlur == 1) {
                madnes_anim_play("reels_bufer_" + i + "_S" + (2 - j), "blur");
            } else {
                madnes_anim_play("reels_bufer_" + i + "_S" + (2 - j), "stop");
            }
        }
    }
    all_set_for_stop = 1;
    joker27plus_rotate_stop_loading = 0;
    set_rotated(0);
}

var joker27plus_start_delay = 0;

function joker27plus_control_stop_sound(reel)
{
    madnes_audio_play("reel_stop");

    var up_sym = server_result.result.reelMatrix[0][reel][0];
    var mi_sym = server_result.result.reelMatrix[0][reel][1];
    var dn_sym = server_result.result.reelMatrix[0][reel][2];

    if(up_sym == 8 || mi_sym == 8 || dn_sym == 8)
    {
        madnes_audio_play("symbol_Joker_" + reel);
    }

    if(reel == 2)
    {
        if(
            server_result.result.reelMatrix[0][0][1] == server_result.result.reelMatrix[0][1][1] &&
            server_result.result.reelMatrix[0][1][1] == server_result.result.reelMatrix[0][2][1]
        )
        {
            //madnes_audio_play("bonus_FreeSpins_Prepare");
            joker27plus_start_delay = 500;
        }
    }
}


// Zacatek kontroly vyher
var result_control_pos = 0;
function joker27plus_result_control()
{
    madnes_reels_stop();
    if(!in_free_spins)
    {
        set_blink_state(""); //blink_state = "";
    }

    set_inanim(1); // inanim = 1;

    result_control_pos = 0;

    audio_pod_short = 0;
    audio_pod_mid = 0;
    audio_pod_long = 0;

    if(joker27plus_start_delay == 0)
    {
        joker27plus_result_control_part();
    }
    else
    {
        setTimeout(joker27plus_result_control_part, joker27plus_start_delay);
        joker27plus_start_delay = 0;
    }
}

function get_linewins_win_sum(result, calcMultiplier)
{
    var round_win_sum = 0;

    if(result && result['lineWins'] && result['lineWins'].length > 0)
    {
        for(var i = 0; i < result['lineWins'].length; i++)
        {
            if(result['lineWins'][i]['win'] && Number(result['lineWins'][i]['win']) > 0)
            {
                var round_multip = (calcMultiplier && result['lineWins'][i]['multiplier']) ? result['lineWins'][i]['multiplier'] : 1;
                round_win_sum += result['lineWins'][i]['win'] * round_multip;
            }
        }
    }

    return round_win_sum;
}

// function get_round_win_sum(round_id, results, calcMultiplier)
// {
// 	var lines_win_sum = 0;
//
// 	if(results[round_id] && results[round_id]['result'])
// 	{
// 		lines_win_sum = get_linewins_win_sum(results[round_id]['result'], calcMultiplier);
// 	}
//
// 	return lines_win_sum;
// };

/*function results_win_sum(toIndex, results, calcMultiplier)
{
	var results_sum = 0;

	for(var i = 0; i <= toIndex; i++) {
		results_sum += get_round_win_sum(i, results, calcMultiplier);
	}

	return results_sum;
}*/

var joker27plus_result_control_part_fst = true;

// kontrola vyhry na aktualni pozici
var joker27plus_result_control_part_fst_symbol = [];
async function joker27plus_result_control_part()
{
    for(var spos = 0; spos <= 2; spos++)
    {
        for(var cl = 0; cl < cylinder_pos.length; cl++)
        {
            if(madnes_anim_is_playing("reels_bufer_"+cl+"_TMP"+spos))
            {
                setTimeout(function() {joker27plus_result_control_part();},100);
                return;
            }
        }
    }

    if(server_result.result.lineWins == null)
    {
        if(madnes_get_alpha("dark_cover") != 0)
        {
            madnes_alpha_to("dark_cover", 0, 200);
        }

        joker27plus_result_control_part_fst_symbol = [];

        madnes_win_anim_reset();
        if(in_free_spins)
        {
            setTimeout(joker27plus_control_freespins, 100);
        }
        else
        {
            // madnes_show_stop();
            joker27plus_money_add_control();
        }

        if(!in_free_spins)
        {
            set_blink_state(""); //blink_state = "";
        }

        return;
    }
    if(server_result.result.lineWins[result_control_pos] == null)
    {
        if(madnes_get_alpha("dark_cover") != 0)
        {
            madnes_alpha_to("dark_cover", 0, 200);
        }

        joker27plus_result_control_part_fst_symbol = [];

        madnes_win_anim_reset();
        if(in_free_spins)
        {
            setTimeout(joker27plus_control_freespins, 100);
        }
        else
        {
            // madnes_show_stop();
            joker27plus_money_add_control();
        }

        if(!in_free_spins)
        {
            set_blink_state(""); //blink_state = "";
        }

        set_inwincount(false); //inwincount = false;
        return;
    }
    else
    {
        states.setState(STATES.SKIP);

        // madnes_hide_stop();

        if(
            result_control_pos == 0 &&
            joker27plus_result_control_part_fst &&
            server_result.result.lineWins[result_control_pos].multiplier == 2
        )
        {
            joker27plus_result_control_part_fst = false;
            joker27plus_fullplate_start(joker27plus_result_control_part);
            return;
        }

        joker27plus_result_control_part_fst = true;

        if(madnes_win_anim_skip())
        {
            if(
                server_result.result.lineWins[result_control_pos].type == "wild" ||
                server_result.result.lineWins[result_control_pos].type == "normal"
            )
            {
                await madnes_add_win(server_result.result.lineWins[result_control_pos].win * 1); //win = win * 1 + server_result.result.lineWins[result_control_pos].win * 1;
                result_control_pos++;
                joker27plus_result_control_part();
            }
            else
            {
                //console.log(server_result.result.lineWins[result_control_pos]);
                joker27plus_result_control_part_proc(server_result.result.lineWins[result_control_pos]);
            }
        }
        else
        {
            joker27plus_result_control_part_proc(server_result.result.lineWins[result_control_pos]);
        }
    }
}

let fsCurrent = 0;
let fsTotal = 0;
let fsAdd = 0;

// kontrola aktualni vyhry
async function joker27plus_result_control_part_proc(win_set)
{
    // (Caru -> zvuk) -> zabarvit -> otocit -> prostrelit -> otocit zpet -> posunout
    set_inwincount(true); //inwincount = true;
    var linenum = 0;
    if(win_set.line != null && typeof win_set.line != "undefined" && win_set.line >= 0)
    {
        linenum = 1;
    }

    if(linenum != 0)
    {
        // madnes_win_anim_add();
        madnes_audio_pause('background');

        await madnes_add_win(win_set.win * 1); //win = win * 1 + win_set.win * 1;
        joker27plus_result_control_part_proc_trn(win_set);
    }
    else if(win_set.type == "freeSpins")
    {
        set_inwincount(false); //inwincount = false;

        fsCurrent = MV.freespins.getFreeSpinNumber();
        MV.game.freespins.run(new AddResult(server_result));
        fsTotal = MV.freespins.getFreeSpinNumber();
        fsAdd = 0;

        let fsCount = fsTotal - fsCurrent;

        if(!in_free_spins)
        {
            madnes_audio_pause('background');
            madnes_audio_play('FS_START');
            setTimeout(madnes_audio_loop.bind(null, 'FS_BG'), 1000);
        }

        if(fsCurrent*1 != fsTotal /*in_free_spins_total*1 != server_result.result.freeSpinNumber*1*/)
        {
            //setTimeout("joker27plus_add_free_spins()", 800);

            joker27plus_fs_start_anim(fsCount, joker27plus_add_free_spins);
            return;
        }

        if(!in_free_spins)
        {
            set_in_free_spins(true); //in_free_spins = true;
            // in_free_spins_pos = 0;
            setTimeout(joker27plus_control_freespins, 2000);
        }
        else
        {
            setTimeout(joker27plus_control_freespins, 1000);
        }

    }
    else
    {
        result_control_pos++;
        joker27plus_result_control_part();
        // if(in_free_spins)
        // {
        // 	joker27plus_control_freespins();
        // }
    }
}

export function joker27plus_fs_gb_cont()
{
    madnes_audio_fade_out("bg_free_spins_start", 10);
    madnes_audio_loop("bg_free_spins_loop");
}

// Vstup do freespinu + animace pridani spinu
var in_free_spins_tmp = false;
//var joker27plus_fs_start_anim_runned = false;
function joker27plus_add_free_spins()
{
    if(!in_free_spins)
    {
        //if(!joker27plus_fs_start_anim_runned)
        //{
        //	joker27plus_fs_start_anim_runned = true;
        //	joker27plus_fs_start_anim(server_result.result.freeSpinNumber * 1, joker27plus_add_free_spins);
        //	return;
        //}
        //joker27plus_fs_start_anim_runned = false;

        if(madnes_get_alpha("dark_cover") != 0)
        {
            madnes_alpha_to("dark_cover", 0, 200);
        }

        set_in_free_spins(true); // in_free_spins = true;
        // in_free_spins_pos = 0;

        in_free_spins_tmp = true;

        madnes_set_text("freespins_text", "0/0");

        madnes_move_to("logo", wi / 2, -80, 250, function() {
            madnes_set_pos_y("logo", -200);
            madnes_set_pos_y("freespins_head", -80);
            madnes_move_to("freespins_head", wi / 2, 0, 250, joker27plus_add_free_spins);

            madnes_alpha_to("freespins_reels", 1, 250, joker27plus_fs_vibrate_end);

            setTimeout(madnes_audio_play.bind(this, "bonus_FreeSpins_Prepare"), 500);


            /*
            madnes_audio_fade_out("bg_main", 400);
            madnes_audio_play("bg_free_spins_start");
            setTimeout(joker27plus_fs_gb_cont, 2400);
            */

        });

        return;
    }

    if((fsAdd + fsCurrent) != fsTotal /*in_free_spins_total * 1 != server_result.result.freeSpinNumber * 1*/)
    {
        if(madnes_get_alpha("dark_cover") != 0)
        {
            madnes_alpha_to("dark_cover", 0, 200);
        }

        set_blink_state(""); //blink_state = "";
        // if(in_free_spins_total == 0)
        // {
        // 	var cname = "lfspos_" + server_config.session_id;
        // 	var end_spin = madnes_get_cookie(cname);
        // 	if(typeof end_spin == "undefined")
        // 	{
        // 		end_spin = 0;
        // 	}
        // 	in_free_spins_pos = end_spin;
        // 	if(end_spin > 0)
        // 	{
        // 		win = server_result.result.freeSpinResults[end_spin - 1].result.win;
        // 		server_result.result.freeSpinNumber = server_result.result.freeSpinResults[end_spin - 1].result.freeSpinNumber;
        // 	}
        // }
        madnes_audio_play("bonus_FreeSpins_Counter");
        // in_free_spins_total++;

        fsAdd++;

        if(in_free_spins)
        {
            madnes_set_text("freespins_text", MV.freespins.getRoundNumber() + "/" + (fsCurrent + fsAdd));
        }
        else
        {
            madnes_set_text("freespins_text", "0/0");
        }

        setTimeout(function()
        {
            joker27plus_add_free_spins();
        }, 120);
    }
    else
    {
        if(MV.game.freespins.isSkipping()) {
            madnes_set_win(MV.game.freespins.getResultWin())
        }

        if(!in_free_spins || in_free_spins_tmp)
        {
            in_free_spins_tmp = false;
        }

        setTimeout(joker27plus_control_freespins, 1000);
    }
}

var result_tmp; // uchovava docasne vysledek freespinu, je-li to potreba

// kontrola freespinu

async function joker27plus_control_freespins()
{
    let pos = MV.game.freespins.getRoundIndex() + 1;

    if(server_result.result.freeSpinResults[pos] == null || typeof server_result.result.freeSpinResults[pos] == "undefined")
    {
        if(in_free_spins) {
            set_in_free_spins(false); //in_free_spins = false;



            // var cname = "lfspos_" + server_config.session_id;
            // madnes_set_cookie(cname, "0");

            madnes_move_to("freespins_head", wi / 2, -80, 250, function() {
                madnes_set_pos_y("freespins_head", -200);
                madnes_set_pos_y("logo", -80);
                madnes_move_to("logo", wi / 2, 0, 250, joker27plus_control_freespins);

                madnes_alpha_to("freespins_reels", 0, 250);

                madnes_audio_fade_out("bg_free_spins_loop", 700);

                setTimeout(function() {
                    madnes_audio_set_volume('bg_main', 0);
                    madnes_audio_loop('bg_main');
                    madnes_audio_fade_to('bg_main', behavior_config.sound.background.background, 1600);
                }, 1600);

            });

            return;
        }

        in_free_spins_tmp = false;
        // in_free_spins_pos = 0;
        // in_free_spins_total = 0;

        //madnes_end_round();

        madnes_set_text("freespins_text", "0/0");

        madnes_audio_stop('FS_BG');

        joker27plus_money_add_control_freespins_start({});
    }
    else
    {
        let server_result_tmp = server_result;
        let num = MV.game.freespins.getFreeSpinNumber();

        if (
            behavior_config.sound.background.freeSpinsBackground != madnes_audio_get_volume('bg_free_spins_loop') &&
            madnes_audio_get_volume('bg_free_spins_loop') != 0
        ) {
            madnes_audio_fade_to('bg_free_spins_loop', behavior_config.sound.background.freeSpinsBackground, 400);
        }

        if (madnes_get_alpha("dark_cover") != 0) {
            madnes_alpha_to("dark_cover", 0, 200);
        }

        set_result_lock(1); //result_lock = 1;

        await madnes_end_round();

        setTimeout(() => {
            set_result_lock(0); // result_lock = 0;

            set_server_result(server_result_tmp);
            server_result.result.freeSpinNumber = server_result.result.freeSpinResults[pos].result.freeSpinNumber;
            server_result.result.reelMatrix = server_result.result.freeSpinResults[pos].result.reelMatrix;
            server_result.result.lineWins = server_result.result.freeSpinResults[pos].result.lineWins;
            server_result.result.gameSpecifics = server_result.result.freeSpinResults[pos].result.gameSpecifics;

        }, 500);

        set_rotated(0); //rotated = 0;

        if (in_free_spins) {
            madnes_set_text("freespins_text", (pos + 1) + "/" + num);
        } else {
            madnes_set_text("freespins_text", "0/0");
        }


    }
}

export var win_type;
var j27p_freespins_data = null;
function joker27plus_money_add_control_freespins_start(freespinsData)
{
    win_type = 'fs';
    j27p_freespins_data = freespinsData;

    joker27plus_windesk_show();
}

function madnes_min_mun_to(name, sum, multi)
{
    //madnes_alpha_to(name, 1, 200);
    setTimeout(madnes_alpha_to.bind(this, name, 1, 300), 80);
    setTimeout(madnes_alpha_to.bind(this, name, 0, 160), 800);

    madnes_set_scale(name, 0.4, 0.4);
    setTimeout(madnes_scale_to.bind(this, name, 1, 1, 200), 1);
    setTimeout(madnes_scale_to.bind(this, name, 1.3, 1.3, 200), 201);
    setTimeout(madnes_scale_to.bind(this, name, 1, 1, 200), 401);
    setTimeout(madnes_scale_to.bind(this, name, 0, 0, 400), 801);

    madnes_set_text(name, 0);

    var total = 10;
    var total_time = 400;
    for(var i = 1; i <= total; i++)
    {
        setTimeout(madnes_set_text.bind(this, name, Math.round( sum * ( 1 / total ) * i ) ), total_time * ( ( 1 / total ) * i ) );
    }

    if(multi > 1)
    {
        var reel = name.replace("reels_bufer_", "");
        reel = reel.replace("TEXT0", "");
        reel = reel.replace("TEXT1", "");
        reel = reel.replace("TEXT2", "");

        var top = 2 - name.substr(name.length - 1);

        var top_add = 0;
        var left_add = 0;
        switch(Math.floor(Math.random()*3))
        {
            case 0:
                top_add = -80;
                break;
            case 1:
                top_add = 20;
                left_add = -100;
                break;
        }
        madnes_set_alpha("x2_lines_light_on_" + reel, 0);

        madnes_set_pos("x2_lines_" + reel, cylinder_pos[reel] + 60 + left_add, 200 + top * ico_he + top_add);

        madnes_set_scale("x2_lines_" + reel, 0.4, 0.4);
        madnes_set_alpha("x2_lines_" + reel, 0);

        setTimeout(madnes_alpha_to.bind(this,"x2_lines_" + reel, 1, 200),401);
        setTimeout(madnes_scale_to.bind(this,"x2_lines_" + reel, 1.2, 1.2, 200),401);
        setTimeout(madnes_scale_to.bind(this,"x2_lines_" + reel, 1.0, 1.0, 200),601);
        setTimeout(madnes_alpha_to.bind(this,"x2_lines_" + reel, 0, 150), 1200);

        setTimeout(madnes_alpha_to.bind(this,"x2_lines_light_on_" + reel, 1, 200), 400);
        setTimeout(madnes_alpha_to.bind(this,"x2_lines_light_on_" + reel, 0, 200), 600);
        setTimeout(madnes_alpha_to.bind(this,"x2_lines_light_on_" + reel, 1, 200), 800);
        setTimeout(madnes_alpha_to.bind(this,"x2_lines_light_on_" + reel, 0, 200), 1000);

        if(reel == 0)
        {
            setTimeout(madnes_audio_play.bind(this,"misc_Multiplier_Bell"), 400);
        }

    }

}



var audio_pod_short = 0;
var audio_pod_mid = 0;
var audio_pod_long = 0;

// Otoceni wild symbolu
function joker27plus_result_control_part_proc_trn(win_set)
{
    // Caru -> zvuk -> zabarvit -> (otocit) -> prostrelit -> otocit zpet -> posunout
    for(var spos = 0; spos <= 2; spos++)
    {
        for(var cl = 0; cl < cylinder_pos.length; cl++)
        {
            if(madnes_anim_is_playing("reels_bufer_"+cl+"_TMP"+spos))
            {
                setTimeout(function() {joker27plus_result_control_part_proc_trn(win_set);},300);
                return;
            }
        }
    }

    joker27plus_print_reels();

    if(
        behavior_config.sound.background.background == madnes_audio_get_volume('bg_main') &&
        madnes_audio_get_volume('bg_main') != 0
    )
    {
        madnes_audio_fade_to('bg_main', behavior_config.sound.background.background / 2, 400);
    }

    if(
        behavior_config.sound.background.freeSpinsBackground == madnes_audio_get_volume('bg_free_spins_loop') &&
        madnes_audio_get_volume('bg_free_spins_loop') != 0
    )
    {
        madnes_audio_fade_to('bg_free_spins_loop', behavior_config.sound.background.freeSpinsBackground * 0.45, 400);
    }


    var audio = "win_low_1";
    var audio2 = "";

    if(
        win_set.symbol == 0 || // cherry
        win_set.symbol == 1 || // orange
        win_set.symbol == 2 || // dollar
        win_set.symbol == 3    // plum

    )
    {
        audio = "win_low_" + ( audio_pod_short++ % 6 + 1);
    }/*
	else if(
		win_set.symbol == 3 || // plum
		win_set.symbol == 4 || // bell
		win_set.symbol == 5    // melone
	)
	{
		audio = "win_mid_" + ( audio_pod_mid++ % 6 + 1);
	}*/
    else if(
        win_set.symbol == 4 || // bell
        win_set.symbol == 5 || // melone
        win_set.symbol == 6 || // star
        win_set.symbol == 7    // bar
    )
    {
        audio = "win_high_" + ( audio_pod_long++ % 6 + 1);
    }
    else
    {
        audio = "win_joker_3x";
    }

    var symbol = picture_convert[win_set.symbol];
    var symbol_count = win_set.position.length;
    symbol = symbol.split("_");
    symbol = symbol[1].toUpperCase();
    var audio_name = "WIN_LINE_"+symbol.toUpperCase()+"_"+symbol_count;
    madnes_audio_play(audio_name);


    var fst_run = 0;

    set_blink_state("wincount"); // blink_state = "wincount";

    //joker27plus_show_win_sum_start(win_set);
    for(var pos in win_set.position)
    {
        var anim_name = "anim";
        var txt = madnes_get_texture("reels_bufer_"+win_set.position[pos][0]+"_S"+(2-win_set.position[pos][1])).replace(/_blur/, "");

        if(txt == "symbol_Joker")
        {

            if(win_set.symbol == 8)
            {
                // all jokers
            }
            else if(
                win_set.symbol == 0 || // cherry
                win_set.symbol == 1 || // orange
                win_set.symbol == 2 || // dollar
                win_set.symbol == 3 || // plum
                win_set.symbol == 4    // bell
            )
            {
                // short
                txt = "symbol_Joker_short";
                audio2 = "win_low_with_joker";
            }
            else if(
                win_set.symbol == 5 || // melone
                win_set.symbol == 6 || // star
                win_set.symbol == 7    // bar
            )
            {
                // long
                txt = "symbol_Joker_long";
                audio2 = "win_high_with_joker";
            }
            else
            {
                console.log(win_set.symbol);
                txt = "symbol_Joker_long";
            }

            if(
                win_set.symbol == 0 || // cherry
                win_set.symbol == 1 || // orange
                win_set.symbol == 2    // dollar

            )
            {
                // short
                audio2 = "win_low_with_joker";
            }
            else if(
                win_set.symbol == 3 || // plum
                win_set.symbol == 4 || // bell
                win_set.symbol == 5    // melone
            )
            {
                // mid
                audio2 = "win_mid_with_joker";
            }
            else if(

                win_set.symbol == 6 || // star
                win_set.symbol == 7    // bar
            )
            {
                // long
                audio2 = "win_high_with_joker";
            }

        }

        if(joker27plus_result_control_part_fst_symbol.indexOf(txt) == -1)
        {
            joker27plus_result_control_part_fst_symbol[joker27plus_result_control_part_fst_symbol.length] = txt;
            //fst_run = 1;
        }

        madnes_set_texture("reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]), txt);
        madnes_set_scale("reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]), 1, madnes_get_scale_y("reels_bufer_"+win_set.position[pos][0]+"_S"+(2-win_set.position[pos][1])));
        for(var anim in icons[txt])
        {
            madnes_anim_add("reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]), anim, icons[txt][anim]);
        }

        if(madnes_get_pos_y("reels_bufer_"+win_set.position[pos][0]+"_S"+(2-win_set.position[pos][1])) > 0)
        {
            madnes_set_pos_y(
                "reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]),
                madnes_get_pos_y("reels_bufer_"+win_set.position[pos][0]+"_S"+(2-win_set.position[pos][1]))
            );

            madnes_set_pos_y(
                "reels_bufer_"+win_set.position[pos][0]+"_S"+(2-win_set.position[pos][1]),
                -9999
            );
        }

        if(madnes_get_alpha("dark_cover") == 0)
        {
            madnes_alpha_to("dark_cover", 1, 200);
        }

        /*
        if(win_set.symbol >= 5)
        {
            madnes_anim_play("reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]), anim_name, 20);
        }
        else
        {
            madnes_anim_play("reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]), anim_name, 30);
        }
        */
    }

    if(fst_run == 1)
    {
        joker27plus_print_reels();
    }
    //debugger;
    var add11 = 0;
    if(result_control_pos == 0)
    {
        add11 = 400;
    }

    for(var pos in win_set.position)
    {
        madnes_min_mun_to("reels_bufer_"+win_set.position[pos][0]+"TEXT"+(2-win_set.position[pos][1]), madnes_money_to_coin(win_set.win), win_set.multiplier)

        if(win_set.symbol >= 5)
        {
            if(fst_run == 1)
            {
                madnes_set_alpha("reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]), 0.1);
                setTimeout(
                    function(smb, anim_name)
                    {
                        madnes_set_pos_y(smb,madnes_get_pos_y(smb.replace("_TMP", "_S")));
                        madnes_set_pos_y(
                            smb.replace("_TMP", "_S"),
                            -9999
                        );
                        madnes_set_alpha(smb, 1);
                        madnes_anim_play(smb, anim_name, 30);
                    }.bind(this, "reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]), anim_name)
                    , 100 + add11);

            }
            else
            {
                madnes_anim_play("reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]), anim_name, 45);
            }
        }
        else
        {
            if(fst_run == 1)
            {
                madnes_set_alpha("reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]), 0.1);
                //setTimeout(madnes_anim_play.bind(this, "reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]), anim_name, 30), 400)
                setTimeout(
                    function(smb, anim_name)
                    {
                        madnes_set_pos_y(smb,madnes_get_pos_y(smb.replace("_TMP", "_S")));
                        madnes_set_pos_y(
                            smb.replace("_TMP", "_S"),
                            -9999
                        );
                        madnes_set_alpha(smb, 1);
                        madnes_anim_play(smb, anim_name, 30);
                    }.bind(this, "reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]), anim_name)
                    , 100 + add11);
            }
            else
            {
                madnes_anim_play("reels_bufer_"+win_set.position[pos][0]+"_TMP"+(2-win_set.position[pos][1]), anim_name, 45);
            }
        }
    }

    if(fst_run == 1)
    {
        setTimeout(
            function(audio)
            {
                if(madnes_audio_is_playing(audio))
                {
                    madnes_audio_stop(audio);
                    madnes_audio_play(audio);
                }
                else
                {
                    madnes_audio_play(audio);
                }
            }.bind(this, audio), 100 + add11);
    }
    else
    {
        if(madnes_audio_is_playing(audio))
        {
            madnes_audio_stop(audio);
            madnes_audio_play(audio);
        }
        else
        {
            madnes_audio_play(audio);
        }
    }

    if(audio2 != "")
    {
        if(fst_run == 1)
        {
            setTimeout(
                function(audio2)
                {
                    madnes_audio_play(audio2);
                }.bind(this, audio2), 100 + add11);
        }
        else
        {
            madnes_audio_play(audio2);
        }
        /*
        if(madnes_audio_is_playing(audio2))
        {
            madnes_audio_stop(audio2);
            madnes_audio_play(audio2);
        }
        else
        {
            madnes_audio_play(audio2);
        }
        */
    }

    result_control_pos++;

    setTimeout(joker27plus_result_control_part, 800);

}

var win_anim_played = false;
export function set_win_anim_played(bool) {
    win_anim_played = bool;
}

// Zacatek kontroly pridavani penez
export function joker27plus_money_add_control(nobigwin)
{
    set_inwincount(false); //inwincount = false;

    set_blink_state(""); //blink_state = "";

    if(!win_anim_played && win * 1 > 0)
    {

        if( win * lines_count >= madnes_get_atomic_bet() * big_win && typeof nobigwin == "undefined")
        {
            set_inbigwin(true);
            win_type = 'win';
            joker27plus_windesk_show();
            return;
        }

        joker27plus_money_add_win();
    }
    else
    {
        madnes_audio_continue('background');

        // madnes_hide_stop();

        set_inanim(0); //inanim = 0;

        // var ended = true;
        // if(j27p_freespins_data) {
        // 	ended = j27p_freespins_data.ended;
        // }
        //
        // madnes_end_round(ended, {}, j27p_freespins_data, function () {
        //
        // 	// madnes_show_btns();
        // 	end_result_control();
        //
        // });

        // if(autostart == "∞" || autostart*1 > 0)
        // {
        // 	if(madnes_money_to_coin(money) < bet)
        // 	{
        // 		autostart = 0;
        // 	}
        // 	else
        // 	{
        // 		joker27plus_rotate_start();
        // 	}
        // }

        if(
            behavior_config.sound.background.background != madnes_audio_get_volume('bg_main') &&
            madnes_audio_get_volume('bg_main') != 0
        )
        {
            madnes_audio_fade_to('bg_main', behavior_config.sound.background.background, 400);
        }

        madnes_end_round();
    }
}

export function joker27plus_end_round_recalced()
{
    set_inwincount(false); //inwincount = false;
    set_inmoneyadd(false); // inmoneyadd = 0;
    set_inanim(false); // inanim = 0;
    win_anim_played = false;
    // j27p_freespins_data = null;

    // madnes_on_end_round_recount(win);
    // madnes_on_round_end();
    // madnes_recount_bet();

    // if(is_in_autostart())
    // {
    // 	madnes_rotate_start();
    // }
}

function is_in_autostart()
{
    return !!autostart;
    //return autostart * 1 > 0 || autostart == "∞";
}

var moneyadd_pos = 0;
var moneyadd_dir = 0;
var joker27plus_money_add_win_speed = 18;
function joker27plus_money_add_win()
{
    set_inanim(1); //inanim = 1;

    win_anim_played = true;

    madnes_show_money( madnes_money_to_coin(win) , function() {

        joker27plus_money_add_control();

    });

    set_inmoneyadd(0); //inmoneyadd = 0;
    set_inbigwin(0); // inbigwin = 0;
}
// Konec kontroly penez

function get_fs_end_data(fs_pos) {

    if(!server_result['result']['freeSpinResults']) {
        return {};
    }

    var _fs_win = 0;
    var _fs_res = server_result['result']['freeSpinResults'];

    if(fs_pos <= 0) {
        _fs_win = get_linewins_win_sum(server_result.result);
    } else {
        _fs_win = get_linewins_win_sum(_fs_res[fs_pos - 1]['result']);
    }

    return {
        "ended": server_result.result.freeSpinResults.length == fs_pos,
        "win": _fs_win,
        "order": fs_pos,
        "count": server_result.result.freeSpinResults.length
    }
}

